// extracted by mini-css-extract-plugin
module.exports = {"container":"_2YTJb5MPmFecQM46AtJ-de categoriesLayout_category","header":"_2e7gfRdGt3VKYrxKdJwpZx loadingGlow"};